/**
 * WARNING: This file was auto-generated by svgr. Do not edit.
 */
import * as React from 'react'
import type { SVGProps } from 'react'
/**
 * @internal
 */
const SvgBroadcastIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12m0-4a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M4.93 4.93a1 1 0 0 1 0 1.41A9.97 9.97 0 0 0 2 12c0 2.21.72 4.26 1.93 5.93a1 1 0 1 1-1.57 1.24A11.96 11.96 0 0 1 0 12c0-2.87 1.01-5.5 2.69-7.56a1 1 0 0 1 1.58-.1zm14.14 0a1 1 0 0 1 1.24-1.57A11.96 11.96 0 0 1 24 12c0 2.87-1.01 5.5-2.69 7.56a1 1 0 0 1-1.58.1l-.66-.59a1 1 0 0 1 0-1.41A9.97 9.97 0 0 0 22 12c0-2.21-.72-4.26-1.93-5.66a1 1 0 0 1 0-1.41z"
    />
  </svg>
)
export default SvgBroadcastIcon
